import {router} from 'app/router/main';

const transcribeDevicesURL = () => router.url('transcribeDevices');
const transcribeDeviceDetailsURL = (deviceId) => router.url('transcribeDeviceDetails', {deviceId});

export {
  transcribeDeviceDetailsURL,
  transcribeDevicesURL,
};
